module.exports = __webpack_public_path__ + "static/media/HotRolling1.95fdcd6d.png";